export default "__VITE_ASSET__08938b45__"